import React from 'react'

function ModelManag() {
  return (
    <div>ModelManag</div>
  )
}

export default ModelManag